var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('IndustrySelect',{ref:"select",staticClass:"flex_1",attrs:{"label-text":_vm.labelText},model:{value:(_vm.selectedValues),callback:function ($$v) {_vm.selectedValues=$$v},expression:"selectedValues"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }